import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TranslateDirective } from '../../Utilites/Directives/translate.directive';

@Component({
    selector: 'app-pageunauthorized',
    imports: [
        MatButtonModule,
        RouterModule,
        TranslateDirective
    ],
    templateUrl: './pageunauthorized.component.html',
    styleUrl: './pageunauthorized.component.scss'
})
export class PageunauthorizedComponent {

}
